import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=5f782747&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=ts"
export * from "./Privacy.vue?vue&type=script&lang=ts"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=5f782747&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f782747",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VCard,VCardText,VContainer,VMain})
